<template>
  <div class="container">
    <HMModalHeader
      :title="$t('COMMUNITY.TITLE.SEND_A_DIRECT_MESSAGE')"
      @close="onDiscard"
    />
    <div ref="wrapper" class="community-chat-users-container pt-4 pb-3 w-100">
      <v-select
        @search="searchUsers"
        v-model="selectedMember"
        :options="users"
        label="full_name"
        code="id"
        :reduce="member => member"
        :placeholder="$t('COMMUNITY.TEXT.FIND_MEMBER_TO_MESSAGE')"
        class="users-selector mb-4"
      >
        <template v-slot:option="option">
          <div class="d-flex">
            <div v-if="option.image">
              <HMPhotoIcon
                :instructor="{ image: option.image }"
                size="24px"
                class="mr-2"
              />
            </div>
            <div v-else>
              <HMPhotoIcon
                :instructor="{ image: '/assets/images/avatar.svg' }"
                size="24px"
                class="mr-2"
              />
            </div>
            {{ option.label }}
          </div>
        </template>
      </v-select>
    </div>
    <form @submit.prevent="onConfirm">
      <HMModalFooter
        :submitButton="$t('GENERAL.BUTTON.SEND')"
        :discardButton="$t('GENERAL.BUTTON.CLOSE')"
        @close="onDiscard"
      />
    </form>
  </div>
</template>

<script>
import Vue from 'vue';
import { errorToMessage } from '@/core/utils/errors';
import { mapGetters } from 'vuex';
import { getStudioURL } from '@/web/router/custom-domain-utils';
import _ from 'lodash';

export default Vue.extend({
  name: 'CommunityNewDMChatModal',
  props: {
    confirm: null,
  },
  data() {
    return {
      selectedMember: null,
      users: [],
    };
  },
  methods: {
    searchUsers: _.throttle(async function (query) {
      try {
        if (!query || query.length < 1) {
          this.users = [];
          return;
        }
        const foundUsers = await this.$store.dispatch('community/searchUsers', {
          studioURL: getStudioURL(this.$route),
          query,
        });

        this.users = foundUsers.map(user => {
          return {
            ...user,
            label: user.full_name,
          };
        });
      } catch (error) {
        this.$notify({
          group: 'app',
          type: 'error',
          title: this.$t('NOTIFICATIONS.TITLE.ERROR'),
          text: errorToMessage(error.response),
          duration: -1,
        });
      }
    }, 500),
    async onConfirm() {
      this.confirm(this.selectedMember);
      this.$emit('close');
    },
    async onDiscard() {
      if (this.discard) {
        await this.discard();
      }
      this.$emit('close');
    },
  },
});
</script>

<style lang="scss" scoped>
@import '@/web/styles/components-variables.scss';
.v-select {
  .vs__dropdown-menu {
    z-index: 2;
    position: relative;
  }
}

.community-chat-users-container {
  min-height: 400px;
}
</style>
